export default "__VITE_ASSET__BMSp8BKi__"